export const Journal = () => {
  return (
    <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 1H12.2C11.3513 1 10.5374 1.32778 9.93726 1.91122C9.33714 2.49467 9 3.28599 9 4.11111V15C9 15 9.81818 13 12 13C14.1818 13 17 13 17 13V1Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1H5.8C6.64869 1 7.46263 1.32778 8.06274 1.91122C8.66286 2.49467 9 3.28599 9 4.11111V15C9 15 8.18182 13 6 13C3.81818 13 1 13 1 13V1Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
